var map = {
	"./icon-admin.svg": 66882,
	"./icon-bianji.svg": 55702,
	"./icon-config.svg": 75905,
	"./icon-dangdifill.svg": 45579,
	"./icon-daohang.svg": 66382,
	"./icon-duanxin.svg": 71555,
	"./icon-editor.svg": 48211,
	"./icon-geren.svg": 79042,
	"./icon-jiesuo.svg": 49652,
	"./icon-job.svg": 54878,
	"./icon-log.svg": 64677,
	"./icon-menu.svg": 73701,
	"./icon-mudedi.svg": 45866,
	"./icon-oss.svg": 9315,
	"./icon-pinglun.svg": 85592,
	"./icon-role.svg": 91534,
	"./icon-shanchu.svg": 35543,
	"./icon-shezhi.svg": 73863,
	"./icon-shoucang.svg": 64778,
	"./icon-shoucangfill.svg": 28195,
	"./icon-shouye.svg": 24390,
	"./icon-sousuo.svg": 60213,
	"./icon-sql.svg": 4183,
	"./icon-suoding.svg": 81923,
	"./icon-system.svg": 3199,
	"./icon-tixing.svg": 5049,
	"./icon-tubiao.svg": 59181,
	"./icon-xiangqu.svg": 20365,
	"./icon-xiangqufill.svg": 61751,
	"./icon-zhedie.svg": 96231,
	"./icon-zonghe.svg": 44123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40240;